(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const formatMoney = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  const freeShippingThreshold = 5999;

  const header = $('[data-smart-header]');
  let lastY = window.scrollY;
  let ticking = false;
  const updateHeader = () => {
    const y = window.scrollY;
    const delta = y - lastY;
    if (y < 24 || delta < -7) header?.classList.remove('is-hidden');
    else if (y > 130 && delta > 7) header?.classList.add('is-hidden');
    lastY = y;
    ticking = false;
  };
  addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(updateHeader); ticking = true; } }, { passive: true });

  const menu = $('[data-mobile-menu]');
  const menuScrim = $('[data-menu-scrim]');
  const setMenu = (open) => {
    menu?.classList.toggle('is-open', open);
    menu?.setAttribute('aria-hidden', String(!open));
    if (menuScrim) { menuScrim.hidden = !open; menuScrim.classList.toggle('is-open', open); }
    document.body.classList.toggle('drawer-locked', open);
  };
  $('[data-menu-open]')?.addEventListener('click', () => setMenu(true));
  $('[data-menu-close]')?.addEventListener('click', () => setMenu(false));
  menuScrim?.addEventListener('click', () => setMenu(false));

  const searchToggle = $('[data-search-toggle]');
  const searchPanel = $('[data-search-panel]');
  const setSearchOpen = (open) => {
    if (!searchPanel) return;
    searchPanel.hidden = !open;
    searchToggle?.setAttribute('aria-expanded', String(open));
    if (open) $('[data-predictive-input]', searchPanel)?.focus({ preventScroll: true });
  };
  searchToggle?.addEventListener('click', () => setSearchOpen(searchPanel.hidden));
  document.addEventListener('pointerdown', (event) => {
    if (!searchPanel || searchPanel.hidden || searchPanel.contains(event.target) || searchToggle?.contains(event.target)) return;
    setSearchOpen(false);
  });

  const escapeHTML = (value = '') => String(value).replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  const productImage = (product) => window.DearLumo?.assets?.[product.handle] || product.featured_image?.url || product.image || '';
  $$('[data-predictive-form]').forEach((form) => {
    const input = $('[data-predictive-input]', form);
    const results = $('[data-predictive-results]', form);
    if (!input || !results) return;
    const initialMarkup = results.innerHTML;
    let timer;
    let request;
    const reset = () => {
      request?.abort();
      results.classList.remove('is-loading');
      results.innerHTML = initialMarkup;
      results.hidden = !initialMarkup.trim();
    };
    const renderProducts = (products, query) => {
      results.classList.remove('is-loading');
      if (!products.length) {
        results.innerHTML = `<p class="predictive-empty">No gifts found for “${escapeHTML(query)}”. Try ghost, pumpkin, or mug.</p>`;
        results.hidden = false;
        return;
      }
      results.innerHTML = `<div class="predictive-products">${products.map((product) => {
        const image = productImage(product);
        return `<a class="predictive-product" href="${escapeHTML(product.url)}">${image ? `<img src="${escapeHTML(image)}" alt="">` : ''}<span><strong>${escapeHTML(product.title)}</strong><small>${formatMoney(Math.round(Number(product.price) * 100))}</small></span><b aria-hidden="true">→</b></a>`;
      }).join('')}</div><a class="predictive-view-all" href="/search?q=${encodeURIComponent(query)}&type=product">View all results for “${escapeHTML(query)}” →</a>`;
      results.hidden = false;
      if (!reduceMotion) results.animate(
        [{ opacity: .35, transform: 'translateY(-4px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 240, easing: 'cubic-bezier(.2,.8,.2,1)' }
      );
    };
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const query = input.value.trim();
      if (query.length < 2) { reset(); return; }
      results.hidden = false;
      results.classList.add('is-loading');
      results.innerHTML = '<div class="predictive-loading"><span></span><span></span><span></span></div>';
      timer = setTimeout(async () => {
        request?.abort();
        request = new AbortController();
        try {
          const params = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '4', 'resources[options][unavailable_products]': 'last' });
          const response = await fetch(`/search/suggest.json?${params}`, { signal: request.signal });
          if (!response.ok) throw new Error('Predictive search unavailable');
          const data = await response.json();
          renderProducts(data.resources?.results?.products || [], query);
        } catch (error) {
          if (error.name === 'AbortError') return;
          results.classList.remove('is-loading');
          results.innerHTML = '<p class="predictive-empty">Suggestions are taking a moment. Press Search to continue.</p>';
        }
      }, 140);
    });
  });

  $('[data-collection-sort]')?.addEventListener('change', (event) => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', event.target.value);
    location.assign(url.toString());
  });

  const productRoot = $('[data-product-root]');
  if (productRoot) {
    const variantInput = $('[data-variant-input]', productRoot);
    const price = $('[data-product-price]', productRoot);
    const image = $('[data-product-image]', productRoot);
    const selected = $('[data-selected-style]', productRoot);
    const selectedColor = $('[data-selected-color]', productRoot);
    const colorProperty = $('[data-color-property]', productRoot);
    const combinationText = $('[data-combination-text]', productRoot);
    const addLabel = $('[data-add-label]', productRoot);
    const addButton = $('.add-to-cart', productRoot);
    const chooseVariant = (button) => {
      const id = button.dataset.variantChoice;
      $$('[data-variant-choice]', productRoot).forEach((item) => item.classList.toggle('active', item === button));
      $$('[data-variant-thumb]', productRoot).forEach((item) => item.classList.toggle('active', item.dataset.variantThumb === id));
      variantInput.value = id;
      price.textContent = button.dataset.price;
      image.src = button.dataset.image;
      if (selected) selected.textContent = button.dataset.styleName || button.textContent.trim().replace(button.dataset.price, '').trim();
      if (combinationText) combinationText.textContent = `${button.dataset.styleName} · ${colorProperty?.value || selectedColor?.textContent || ''}`;
      addLabel.textContent = `Add to cart · ${button.dataset.price}`;
      addButton.disabled = button.dataset.available !== 'true';
      image.animate?.([{ opacity: .35, transform: 'scale(.985)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 340, easing: 'cubic-bezier(.2,.8,.2,1)' });
    };
    $$('[data-variant-choice]', productRoot).forEach((button) => button.addEventListener('click', () => chooseVariant(button)));
    $$('[data-color-choice]', productRoot).forEach((button) => button.addEventListener('click', () => {
      const color = button.dataset.colorChoice;
      $$('[data-color-choice]', productRoot).forEach((item) => item.classList.toggle('active', item === button));
      if (selectedColor) selectedColor.textContent = color;
      if (colorProperty) colorProperty.value = color;
      if (combinationText) combinationText.textContent = `${selected?.textContent || ''} · ${color}`;
      if (!reduceMotion) button.animate(
        [{ transform: 'scale(.94)' }, { transform: 'scale(1.03)' }, { transform: 'scale(1)' }],
        { duration: 320, easing: 'cubic-bezier(.2,.85,.25,1)' }
      );
    }));
    $$('[data-variant-thumb]', productRoot).forEach((button) => button.addEventListener('click', () => {
      const choice = $(`[data-variant-choice="${button.dataset.variantThumb}"]`, productRoot);
      if (choice) chooseVariant(choice);
    }));
    const quantity = $('[data-quantity]', productRoot);
    const changeProductQuantity = (direction) => {
      const next = Math.max(1, Number(quantity.value || 1) + direction);
      if (next === Number(quantity.value)) return;
      quantity.value = next;
      if (!reduceMotion) quantity.animate(
        [{ opacity: .3, transform: `translateY(${direction > 0 ? '7px' : '-7px'}) scale(.9)` }, { opacity: 1, transform: 'translateY(0) scale(1)' }],
        { duration: 280, easing: 'cubic-bezier(.2,.85,.25,1)' }
      );
    };
    $('[data-qty-minus]', productRoot)?.addEventListener('click', () => changeProductQuantity(-1));
    $('[data-qty-plus]', productRoot)?.addEventListener('click', () => changeProductQuantity(1));
  }

  const projectorBundle = $('[data-projector-bundle]');
  if (projectorBundle) {
    const variantsNode = $('[data-projector-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const selectedValues = [0, 1].map((index) => $(`[data-projector-option="${index}"].active`, projectorBundle)?.dataset.value || '');
    const variantInput = $('[data-variant-input]', projectorBundle);
    const priceNode = $('[data-product-price]', projectorBundle);
    const compareNode = $('[data-product-compare-price]', projectorBundle);
    const imageNode = $('[data-product-image]', projectorBundle);
    const addButton = $('.projector-add-to-cart', projectorBundle);
    const addLabel = $('[data-add-label]', projectorBundle);
    const stockNode = $('[data-purchase-stock]', projectorBundle);
    const form = $('[data-projector-form]', projectorBundle);
    const feedback = $('[data-projector-feedback]', projectorBundle);
    let selectedTier = 1;
    let mixSelections = [];
    const discountForTier = (tier) => [0, 0, .10, .15, .20][tier] || 0;
    const variantFor = (values) => variants.find((variant) => variant.options.every((value, index) => value === values[index]));
    const money = (cents) => formatMoney(Number(cents || 0));
    const tierTotals = (tier, selections = null) => {
      const rows = selections || Array.from({ length: tier }, () => [...selectedValues]);
      const chosen = rows.map((values) => variantFor(values)).filter(Boolean);
      const subtotal = chosen.reduce((sum, variant) => sum + Number(variant.price), 0);
      const compare = chosen.reduce((sum, variant) => sum + Number(variant.compare_at_price || variant.price), 0);
      return { chosen, subtotal, compare, total: Math.round(subtotal * (1 - discountForTier(tier))) };
    };
    const updateTierPrices = () => {
      for (let tier = 1; tier <= 4; tier += 1) {
        const rows = tier === selectedTier && mixSelections.length === tier ? mixSelections : null;
        const totals = tierTotals(tier, rows);
        const price = $(`[data-tier-price="${tier}"]`, projectorBundle);
        const compare = $(`[data-tier-compare="${tier}"]`, projectorBundle);
        const saving = $(`[data-tier-saving="${tier}"]`, projectorBundle);
        if (price) price.textContent = money(totals.total);
        if (compare) compare.textContent = totals.compare > totals.total ? money(totals.compare) : '';
        if (saving) {
          if (tier === 1) saving.textContent = 'Standard price';
          else saving.textContent = tier === selectedTier ? `You save ${money(totals.compare - totals.total)}` : `Mix any ${tier}`;
        }
      }
    };
    const updateVariant = ({ updateImage = true } = {}) => {
      const variant = variantFor(selectedValues);
      updateTierPrices();
      if (!variant) { addButton.disabled = true; return; }
      variantInput.value = variant.id;
      priceNode.textContent = money(variant.price);
      compareNode.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
      const totals = tierTotals(selectedTier, mixSelections.length === selectedTier ? mixSelections : null);
      addLabel.textContent = `Add to cart · ${money(totals.total)}`;
      addButton.disabled = !variant.available || totals.chosen.length !== selectedTier || totals.chosen.some((item) => !item.available);
      stockNode.textContent = variant.available ? 'In stock' : 'Sold out';
      if (updateImage && variant.featured_image?.src && imageNode) {
        imageNode.src = variant.featured_image.src;
        if (!reduceMotion) imageNode.animate([{ opacity: .35, transform: 'scale(.985)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 320, easing: 'cubic-bezier(.2,.8,.2,1)' });
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    };
    const designValues = [...new Set(variants.map((variant) => variant.options[0]))];
    const sizeValues = [...new Set(variants.map((variant) => variant.options[1]))];
    const optionMarkup = (values, selected) => values.map((value) => `<option value="${escapeHTML(value)}"${value === selected ? ' selected' : ''}>${escapeHTML(value)}</option>`).join('');
    const renderMixRows = () => {
      $$('[data-tier-builder]', projectorBundle).forEach((builder) => {
        const active = Number(builder.dataset.tierBuilder) === selectedTier;
        builder.hidden = !active;
        if (!active) $('[data-mix-rows]', builder).innerHTML = '';
      });
      const activeBuilder = $(`[data-tier-builder="${selectedTier}"]`, projectorBundle);
      const mixRows = $('[data-mix-rows]', activeBuilder);
      mixSelections = Array.from({ length: selectedTier }, (_, index) => mixSelections[index] || [...selectedValues]);
      mixRows.innerHTML = mixSelections.map((values, index) => {
        const variant = variantFor(values);
        const image = variant?.featured_image?.src || '';
        return `<div class="projector-mix-row" data-mix-row="${index}"><img src="${escapeHTML(image)}" alt=""><select data-mix-design aria-label="Box ${index + 1} design">${optionMarkup(designValues, values[0])}</select><select data-mix-size aria-label="Box ${index + 1} size">${optionMarkup(sizeValues, values[1])}</select></div>`;
      }).join('');
      $$('[data-mix-row]', mixRows).forEach((row) => {
        const index = Number(row.dataset.mixRow);
        const sync = () => {
          mixSelections[index] = [$('[data-mix-design]', row).value, $('[data-mix-size]', row).value];
          const variant = variantFor(mixSelections[index]);
          $('img', row).src = variant?.featured_image?.src || '';
          updateTierPrices();
          const totals = tierTotals(selectedTier, mixSelections);
          addLabel.textContent = `Add to cart · ${money(totals.total)}`;
          addButton.disabled = totals.chosen.length !== selectedTier || totals.chosen.some((item) => !item.available);
        };
        $$('select', row).forEach((select) => select.addEventListener('change', sync));
      });
      updateVariant({ updateImage: false });
    };
    $$('[data-projector-option]', projectorBundle).forEach((button) => button.addEventListener('click', () => {
      const index = Number(button.dataset.projectorOption);
      selectedValues[index] = button.dataset.value;
      $$(`[data-projector-option="${index}"]`, projectorBundle).forEach((item) => {
        const active = item === button;
        item.classList.toggle('active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      const selectedLabel = $(`[data-projector-selected="${index}"]`, projectorBundle);
      if (selectedLabel) selectedLabel.textContent = button.dataset.value;
      if (selectedTier === 1) {
        mixSelections = [[...selectedValues]];
        renderMixRows();
      } else updateVariant();
    }));
    $$('[data-projector-tier]', projectorBundle).forEach((button) => button.addEventListener('click', () => {
      selectedTier = Number(button.dataset.projectorTier);
      $$('[data-projector-tier]', projectorBundle).forEach((item) => {
        const active = item === button;
        item.setAttribute('aria-pressed', String(active));
        item.closest('[data-projector-card]')?.classList.toggle('active', active);
      });
      mixSelections = [];
      renderMixRows();
    }));
    const galleryThumbs = $$('[data-projector-thumb]', projectorBundle);
    const showGalleryImage = (index) => {
      if (!galleryThumbs.length) return;
      const normalizedIndex = (index + galleryThumbs.length) % galleryThumbs.length;
      galleryThumbs.forEach((item, itemIndex) => {
        const active = itemIndex === normalizedIndex;
        item.classList.toggle('active', active);
        item.setAttribute('aria-pressed', String(active));
      });
      const button = galleryThumbs[normalizedIndex];
      if (imageNode) {
        imageNode.src = button.dataset.image;
        if (!reduceMotion) imageNode.animate([{ opacity: .35, transform: 'scale(.985)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 260, easing: 'cubic-bezier(.2,.8,.2,1)' });
      }
      const rail = button.parentElement;
      if (rail) rail.scrollTo({ left: Math.max(0, button.offsetLeft - (rail.clientWidth - button.offsetWidth) / 2), behavior: reduceMotion ? 'auto' : 'smooth' });
    };
    galleryThumbs.forEach((button, index) => button.addEventListener('click', () => showGalleryImage(index)));
    $('[data-projector-previous]', projectorBundle)?.addEventListener('click', () => {
      const current = galleryThumbs.findIndex((item) => item.classList.contains('active'));
      showGalleryImage(current - 1);
    });
    $('[data-projector-next]', projectorBundle)?.addEventListener('click', () => {
      const current = galleryThumbs.findIndex((item) => item.classList.contains('active'));
      showGalleryImage(current + 1);
    });
    form?.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const totals = tierTotals(selectedTier, mixSelections.length === selectedTier ? mixSelections : null);
      if (totals.chosen.length !== selectedTier || totals.chosen.some((variant) => !variant.available)) return;
      const grouped = new Map();
      totals.chosen.forEach((variant) => grouped.set(variant.id, (grouped.get(variant.id) || 0) + 1));
      addButton.disabled = true;
      feedback.textContent = 'Adding your bundle…';
      feedback.classList.remove('is-error');
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [...grouped].map(([id, quantity]) => ({ id: Number(id), quantity, properties: { '_DearLumo Bundle': `Mix & Match ${selectedTier}` } })) }),
        });
        if (!response.ok) {
          const problem = await response.json().catch(() => ({}));
          throw new Error(problem.description || problem.message || 'Unable to add bundle');
        }
        addButton.classList.add('added');
        feedback.textContent = 'Added to cart.';
        await openCart();
        setTimeout(() => addButton.classList.remove('added'), 1000);
      } catch (error) {
        feedback.textContent = window.Shopify?.designMode || location.hostname.includes('shopifypreview.com') || location.search.includes('oseid=')
          ? 'Draft preview only — cart works after publishing.'
          : (error.message || 'Unable to add this bundle. Please try again.');
        feedback.classList.add('is-error');
      } finally { addButton.disabled = false; }
    });
    renderMixRows();
    updateVariant();
  }

  const drawer = $('[data-cart-drawer]');
  const scrim = $('[data-cart-scrim]');
  const cartContent = $('[data-cart-content]');
  let cartOpen = false;
  let dragging = null;
  let drawerX = 0;
  let previousShippingProgress = 0;
  const assetFor = (item) => window.DearLumo?.assets?.[item.sku] || item.image || window.DearLumo?.assets?.[item.handle] || '';
  const lineVariantLabel = (item) => [item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '', item.properties?.Color || ''].filter(Boolean).join(' · ');
  const shippingProgressMarkup = (cart) => {
    const remaining = Math.max(0, freeShippingThreshold - cart.total_price);
    const progress = Math.min(1, cart.total_price / freeShippingThreshold);
    const message = remaining > 0
      ? `You're <strong>${formatMoney(remaining)}</strong> away from free shipping`
      : `<strong>Free shipping unlocked!</strong> Your gift is ready to travel.`;
    return `<section class="shipping-progress ${remaining === 0 ? 'is-complete' : ''}" aria-label="Free shipping progress"><div class="shipping-progress-copy"><span>${remaining === 0 ? '✓' : '🚚'}</span><p>${message}</p><small>${formatMoney(cart.total_price)} / $59.99</small></div><div class="shipping-meter"><span data-shipping-fill style="transform:scaleX(${progress})"></span></div></section>`;
  };
  const animateCartFeedback = (cart, direction = 0) => {
    const progress = Math.min(1, cart.total_price / freeShippingThreshold);
    const fill = $('[data-shipping-fill]', cartContent);
    if (fill && !reduceMotion) {
      fill.animate(
        [{ transform: `scaleX(${previousShippingProgress})` }, { transform: `scaleX(${progress})` }],
        { duration: 520, easing: 'cubic-bezier(.2,.82,.2,1)', fill: 'both' }
      );
    }
    const value = $('.quantity-value', cartContent);
    if (value && direction && !reduceMotion) value.animate(
      [{ opacity: .25, transform: `translateY(${direction > 0 ? '8px' : '-8px'}) scale(.86)` }, { opacity: 1, transform: 'translateY(0) scale(1)' }],
      { duration: 300, easing: 'cubic-bezier(.2,.9,.25,1)' }
    );
    if (cart.total_price >= freeShippingThreshold && previousShippingProgress < 1 && !reduceMotion) {
      $('.shipping-progress', cartContent)?.animate(
        [{ transform: 'scale(.985)' }, { transform: 'scale(1.018)' }, { transform: 'scale(1)' }],
        { duration: 520, easing: 'cubic-bezier(.2,.9,.25,1)' }
      );
    }
    previousShippingProgress = progress;
  };
  const setDrawerX = (x) => {
    const width = drawer?.offsetWidth || 500;
    drawerX = Math.max(0, Math.min(width, x));
    drawer.style.transform = `translate3d(${drawerX}px,0,0)`;
    scrim.style.opacity = String(Math.max(0, 1 - drawerX / width));
  };
  const springTo = (target, done) => {
    if (reduceMotion) { setDrawerX(target); done?.(); return; }
    let velocity = 0;
    let position = drawerX;
    let previous = performance.now();
    const frame = (now) => {
      const dt = Math.min(32, now - previous) / 1000;
      previous = now;
      const force = (target - position) * 280;
      velocity = (velocity + force * dt) * Math.pow(.74, dt * 60);
      position += velocity * dt;
      setDrawerX(position);
      if (Math.abs(target - position) < .6 && Math.abs(velocity) < 8) { setDrawerX(target); done?.(); return; }
      requestAnimationFrame(frame);
    };
    requestAnimationFrame(frame);
  };
  const renderCart = (cart, direction = 0) => {
    $$('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; node.classList.remove('count-pop'); void node.offsetWidth; node.classList.add('count-pop'); });
    $('[data-drawer-count]').textContent = `(${cart.item_count})`;
    if (!cart.items.length) {
      cartContent.innerHTML = `${shippingProgressMarkup(cart)}<div class="drawer-empty"><div class="empty-cart-icon">🛍</div><h3>Your cart is empty</h3><p>Add $59.99 in gifts to unlock free shipping.</p><a class="primary-button" href="/collections/halloween">Shop Halloween Gifts →</a></div>`;
      animateCartFeedback(cart, direction);
      return;
    }
    cartContent.innerHTML = `${shippingProgressMarkup(cart)}<section class="drawer-items">${cart.items.map((item, index) => `<article class="drawer-item"><img src="${assetFor(item)}" alt=""><div class="drawer-item-info"><h3>${item.product_title}</h3>${lineVariantLabel(item) ? `<p class="drawer-variant">${lineVariantLabel(item)}</p>` : ''}<p class="gift-ready">🎁 Gift-ready packaging included</p><div class="drawer-item-bottom"><div class="quantity-control"><button type="button" data-line-change="${index + 1}" data-qty="${Math.max(0, item.quantity - 1)}" data-direction="-1" aria-label="Decrease quantity">−</button><span class="quantity-value">${item.quantity}</span><button type="button" data-line-change="${index + 1}" data-qty="${item.quantity + 1}" data-direction="1" aria-label="Increase quantity">+</button></div><button class="remove-button" type="button" data-line-change="${index + 1}" data-qty="0" data-direction="-1">Remove</button><strong>${formatMoney(item.final_line_price)}</strong></div></div></article>`).join('')}</section><div class="drawer-summary"><div class="summary-row"><span>Subtotal</span><strong>${formatMoney(cart.total_price)}</strong></div><p>Shipping and taxes calculated at checkout.</p><a class="checkout-button" href="/checkout">Checkout securely →</a><div class="summary-trust">▣ Secure checkout · Easy order support</div><div class="delivery-note"><span>🎁</span><div><strong>Packed with care</strong><span>Every DearLumo gift is checked before dispatch.</span></div></div></div>`;
    animateCartFeedback(cart, direction);
    $$('[data-line-change]', cartContent).forEach((button) => button.addEventListener('click', async () => {
      button.disabled = true;
      button.classList.add('is-pressed');
      const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(button.dataset.lineChange), quantity: Number(button.dataset.qty) }) });
      renderCart(await response.json(), Number(button.dataset.direction || 0));
    }));
  };
  const refreshCart = async () => { const response = await fetch('/cart.js'); const cart = await response.json(); renderCart(cart); return cart; };
  const openCart = async () => {
    await refreshCart();
    cartOpen = true;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    scrim.classList.add('is-open');
    document.body.classList.add('drawer-locked');
    setDrawerX(drawer.offsetWidth);
    springTo(0);
  };
  const closeCart = () => springTo(drawer.offsetWidth, () => {
    cartOpen = false;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    scrim.classList.remove('is-open');
    document.body.classList.remove('drawer-locked');
  });
  $$('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  $('[data-cart-close]')?.addEventListener('click', closeCart);
  scrim?.addEventListener('click', closeCart);
  $('[data-cart-drag]')?.addEventListener('pointerdown', (event) => {
    if (event.target.closest('button')) return;
    dragging = { start: event.clientX, x: drawerX };
    event.currentTarget.setPointerCapture(event.pointerId);
  });
  $('[data-cart-drag]')?.addEventListener('pointermove', (event) => { if (dragging) setDrawerX(dragging.x + event.clientX - dragging.start); });
  $('[data-cart-drag]')?.addEventListener('pointerup', () => { if (!dragging) return; const shouldClose = drawerX > drawer.offsetWidth * .34; dragging = null; shouldClose ? closeCart() : springTo(0); });

  const addVariant = async (id, quantity = 1, properties = undefined) => {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity, ...(properties ? { properties } : {}) }] }) });
    if (!response.ok) throw new Error('Unable to add this item');
    await openCart();
  };
  $$('[data-quick-add]').forEach((button) => button.addEventListener('click', async () => {
    button.disabled = true;
    try { await addVariant(button.dataset.quickAdd); } finally { button.disabled = false; }
  }));
  $$('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    if (event.submitter && !event.submitter.matches('.add-to-cart')) return;
    event.preventDefault();
    const submit = $('button[type="submit"]', form);
    submit.disabled = true;
    const properties = Object.fromEntries([...form.querySelectorAll('[name^="properties["]')].map((input) => [input.name.slice(11, -1), input.value]).filter(([, value]) => value));
    try { await addVariant($('[name="id"]', form).value, Number($('[name="quantity"]', form).value || 1), Object.keys(properties).length ? properties : undefined); submit.classList.add('added'); setTimeout(() => submit.classList.remove('added'), 1000); } finally { submit.disabled = false; }
  }));

  addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    if (cartOpen) closeCart();
    setMenu(false);
    setSearchOpen(false);
  });
  refreshCart().catch(() => {});
})();
